import React, { Component } from 'react';
import '../../src/styles/Home.css';
import '../../src/styles/Login.css';
import { FaChevronDown } from 'react-icons/fa';
import { Accordion } from 'react-bootstrap';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { userService } from '../_services';
import DocumentMeta from 'react-document-meta';
import { Redirect, Route } from 'react-router-dom';

export class Unsubscribe extends Component {
    displayName = Unsubscribe.name
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            redirectToLogin: false,
            errors: {},
            username: ''
        };
        this.GoToHome = this.GoToHome.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.Unsubscribe();
    }

    handleChange(event) {
        let setvalue = '';
        setvalue = event.target.value
        var self = this;
        self.setState({ [event.target.id]: setvalue });
    }

    Unsubscribe() {
        let errors = {};
        var email = this.props.match.params.email;
        console.log(this.props.match.params.email);
        userService.Unsubscribe(email)
            .then(function (data) {
                console.log(data);
                if (data == "Success") {
                    alert("Please check your inbox (or spam folder) to access your password and then login below.")
                }
                else {
                    // alert(data);
                    errors["Email"] = "* Please enter a valid email address.";
                }
            });
    }

    GoToHome() {
        this.props.history.push('/');
    }

    render() {
        const { user } = this.state;

        const meta = {
            title: "Kluwer Law Online - Unsubscribe",
            canonical: window.location.href,
        }

        if (this.state.redirectToLogin) {

            return <Redirect to={"/Login"} />
        }

        return (
            <DocumentMeta {...meta}>
                <div className="col-12">
                    <div className="White">
                    </div>
                    <div className="White">
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <div className="col-lg-12 BGGrey Loginhomepadding LoginHeight logintop">
                                <p className="LoginText PublicationTitle franziskafont"> Unsubscribe </p>
                                <p className="LoginText">We received your cancellation of your subscription to the Table of contents alert (ETOC) from Kluwer Law Online in good order, you will no longer receive these alerts.
                                    If you want to resubscribe to one or more alerts, you can do so <Link to="/Etoc" className="LinkClass">here</Link>.</p>
                                <p className="LoginText">
                                    If you have any enquiries, please contact us by telephone on + 31 172 64 1562 or send an email to lrs-sales@wolterskluwer.com.</p>
                                <div className="LoginText">
                                    <div className="btn btn-info next" onClick={this.GoToHome} role="button" >Home</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="White">
                    </div>
                    <div className="White">
                    </div>
                </div >
            </DocumentMeta>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Unsubscribe.jsx